import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IndexdbConfigService {
  constructor() {}
  createIndexDB() {
    return new Promise(function (resolve, reject) {
      var request = window.indexedDB.open('ba_ndc', 1);
      request.onerror = function (event: any) {
        console.error('An error occurred with IndexedDB', event);
        resolve(false);
      };
      request.onsuccess = function (event: any) {
        //  console.log("IndexDB created successfully!");
        resolve(request.result);
      };
      request.onupgradeneeded = function (event: any) {
        var xmlLogStore = event.target.result.createObjectStore('ba_ndc_xml_logs', { keyPath: 'id', autoIncrement: true });
        xmlLogStore.createIndex('label', ['label'], { unique: true });
        let perfomanceLogStore = event.target.result.createObjectStore('ba_ndc_perfomance_logs', { keyPath: 'id', autoIncrement: true });
        perfomanceLogStore.createIndex('label', ['label'], { unique: true });
      };
    });
  }
}
